import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { trackEvent } from "@/utils/tracking";

export const StickyBar = ({ product, onBuy, buying }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      setVisible(h > 0 && window.scrollY / h > 0.3);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="sticky-cta-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 z-[60] bg-[#211B10] border-t border-[#A67C1E]/40 px-4 py-3 flex items-center justify-between gap-3"
    >
      <p className="text-[#FBF7EE] font-display text-sm tracking-tight truncate">{product.name}</p>
      <button
        data-testid="sticky-cta-button"
        onClick={() => {
          trackEvent("sticky_cta_clicked", { produk: product.name });
          onBuy("sticky-bar");
        }}
        disabled={buying}
        className="shrink-0 inline-flex items-center gap-1.5 bg-[#A67C1E] text-[#FBF7EE] font-medium text-[11px] uppercase tracking-[0.1em] px-4 py-2.5 disabled:opacity-60"
      >
        Amankan Akses Saya <ArrowUpRight className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};
